const x = (n, o, s, r) => {
  if (!r)
    return n.find(
      (e) => s(e).toLowerCase().startsWith(o.toLowerCase())
    );
  const t = n.filter(
    (e) => s(e).toLowerCase().startsWith(o.toLowerCase())
  );
  if (t.length > 0) {
    let e;
    return t.includes(r) ? (e = t.indexOf(r) + 1, e === t.length && (e = 0), t[e]) : (e = n.indexOf(t[0]), n[e]);
  }
  return r;
};
export {
  x as getNextItemFromSearch
};
//# sourceMappingURL=index.js.map
